import * as React from 'react'

import { TProductDetailMachineTypes } from '~logic/xstate/machines/menu/productDetailMachineTypes'

import { useProductDetailMachine } from '../contexts/ProductDetailMachineProvider'

type TEvents = TProductDetailMachineTypes['events']

type TUpdateNotePayload = Extract<TEvents, { type: 'UPDATE_NOTE' }>['payload']
type TUpdateAmountPayload = Extract<TEvents, { type: 'UPDATE_AMOUNT' }>['payload']
type TUpdateAddonsPayload = Extract<TEvents, { type: 'UPDATE_ADDON_STATE' }>['payload']

/**
 * Functions wrapping productDetailMachine’s events.
 * Used for updating values in product detail modal.
 */
export const useProductDetailStateUpdaters = () => {
  const [, send] = useProductDetailMachine()

  // update the currently selected addons of the single category from the array of addon categories
  const updateAddonState = React.useCallback(
    (payload: TUpdateAddonsPayload) => {
      send({
        type: 'UPDATE_ADDON_STATE',
        payload,
      })
    },
    [send],
  )

  // update the product note
  const updateNote = React.useCallback(
    (payload: TUpdateNotePayload) => {
      send({
        type: 'UPDATE_NOTE',
        payload,
      })
    },
    [send],
  )

  // updates the amount of the entire configured product
  const updateProductAmount = React.useCallback(
    (payload: TUpdateAmountPayload) => {
      send({ type: 'UPDATE_AMOUNT', payload })
    },
    [send],
  )

  return { updateAddonState, updateNote, updateProductAmount }
}
